export const ContractorsMessage = {
  upLoadSuccess: 'ファイルをアップロードしました 。',
  upLoadFail: 'CSVファイルのインポートに失敗しました。',
  invalidCsv: 'ファイルの形式が正しくありません。',
  invalidCsv2: '※登録可能なファイル形式はCSVのみです。',
  csv5M: 'ファイルの最大サイズは、5MBです。',
  subjecCodeRequired: '科目コードは必須です。',
}
